import { lineClamp } from 'components/common/Common';
import Image from 'components/LazyImage/Image';
import { motion } from 'framer-motion/dist/framer-motion';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleCoupon } from 'redux/actions/couponAction';
import styled from 'styled-components';
import { useGetDashboardBlog } from 'untils/hook/blog/blog.hook';
import { flexGap } from 'untils/polyfill/flex';
import {
  MoreLink,
  Section,
  SectionHeader,
  SectionHeaderText,
  SectionSubHeaderText,
} from '../Home.style';

const BlogContainer = styled(Section)`
  @media (max-width: 757px) {
    margin-top: 48px;
    margin-bottom: 48px;
  }
`;

const BlogContentContainer = styled(motion.section)`
  line-height: normal;

  margin-top: 24px;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 757px) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

const BlogLink = styled(Link)`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  position: relative;

  cursor: pointer;
  img {
    aspect-ratio: 4/3;
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 236px;
  }

  @media (max-width: 938px) {
    /* height: 348px; */
  }

  @media (max-width: 757px) {
    /* height: 236px; */

    &::before {
      border-radius: 8px;
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
    }

    .blog-text {
      color: #fff;
      padding: 71px 24px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    img {
      aspect-ratio: 6/2;
    }
  }
`;

const BlogContent = styled.div`
  padding: 48px;
  background: #eff6fa;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${flexGap('24px')}
  color: #07080a;
  .title {
    font-weight: 700;
    margin: 0;
    font-size: var(--fs-900);
    line-height: 42px;
    ${lineClamp}
    padding: ${vw(2)} 0;
  }

  .describe {
    font-weight: 400;
    font-size: var(--fs-800);
    line-height: 30px;
    ${lineClamp};
  }

  @media (max-width: 1380px) {
    padding: 24px;
  }

  @media (max-width: 757px) {
    background: transparent;
    ${flexGap('16px')}

    color: #fff;
    .title {
      color: #fff;
      line-height: 22px;
    }

    .describe {
      line-height: 18px;
    }

    position: absolute;
    left: 0;
    bottom: 0;
  }
`;

const BlogSeparator = styled.hr`
  width: 40px;
  height: 4px;
  background: #07080a;
  @media (max-width: 757px) {
    background: #fff;
  }
`;

const SubText = styled(motion.a)`
  font-weight: var(--fw-bold);
  color: rgba(0, 99, 219, 1);
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: rgba(0, 99, 219, 0.8);
    text-decoration: underline;
  }
`;

const BlogCard = ({ item }) => {
  return (
    <BlogContentContainer
      whileHover={{
        boxShadow: '0px 4px 16px rgba(77, 100, 126, 0.4)',
        transition: { duration: 0.5 },
      }}
    >
      <BlogLink
        key={item.Id}
        to={{
          pathname: item.path,
          state: { blogId: item.info.blogId },
        }}
      >
        <Image src={item.picture} alt={item.altImage} />
        <BlogContent>
          <h3 className="title">{item.info.title}</h3>
          <BlogSeparator />
          <p className="describe">{item.info.describe}</p>
        </BlogContent>
      </BlogLink>
    </BlogContentContainer>
  );
};

const Blog = () => {
  const { isLoading, error, data } = useGetDashboardBlog();
  const dispatch = useDispatch();

  const openCoupon = () => {
    dispatch(
      toggleCoupon({
        couponsShow: true,
        activityState: false,
      })
    );
  };

  if (!data) return null;
  return (
    <BlogContainer>
      <SectionHeader>
        <Link to={'/blog'}>
          <SectionHeaderText>Airacer Blog</SectionHeaderText>
        </Link>

        <SectionSubHeaderText>
          Keep up-to-date on private jet charter popular and exclusive destinations and events. Our
          Airacer blog offers news and event updates for special times of the year and occasions,
          worldwide. <SubText onClick={openCoupon}>Subscribe now</SubText>.
        </SectionSubHeaderText>
      </SectionHeader>
      <BlogCard item={data} />

      <MoreLink to={'/blog'}>More...</MoreLink>
    </BlogContainer>
  );
};

export default Blog;
